






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Card, Icon, Button, ButtonGroup } from '@alpha/ink'
import Redactor from '@/components/Redactor.vue'
import { DO_NOT_TRACK } from '@/utilities/v-track-directive'
import ClickOutside from 'v-click-outside'

@Component({
  directives: {
    clickOutside: ClickOutside.directive
  },
  components: {
    Card,
    Icon,
    Button,
    ButtonGroup,
    Redactor
  }
})
export default class SaveRevertInput extends Vue {
  @Prop({ required: true, default: '' }) testField!: string
  @Prop({ default: false }) staticOnBlur!: boolean
  @Prop({ default: false }) required!: boolean
  @Prop({ default: false }) saving!: boolean
  @Prop({ required: false, default: false }) autofocus!: boolean
  @Prop({ default: '' }) placeholder!: string
  @Prop({ default: 'Click to edit' }) tooltip!: string
  @Prop({ default: DO_NOT_TRACK }) trackingKeyInput!: string

  newTestField = this.testField
  editing = false

  mounted () {
    this.newTestField = this.testField
  }

  @Watch('testField')
  testFieldChanged (val: string) {
    this.newTestField = val || ''
  }

  get focusEnd () {
    return this.autofocus || this.editing
  }

  updateTestField (fieldEdits: string) {
    this.newTestField = fieldEdits
    this.$emit('input', fieldEdits)
  }

  get editMessage () {
    if (this.staticStyle) {
      return this.tooltip
    } else {
      return ''
    }
  }

  async saveChanges () {
    if (!this.editing) return
    this.setEditing(false)
    if (this.newTestField === this.testField) return
    if (this.disableSave) {
      this.newTestField = this.testField
      return
    }
    this.$emit('save', this.newTestField)
  }

  get disableSave () {
    return this.required && this.newTestField === ''
  }

  get staticStyle () {
    return this.staticOnBlur && !this.editing
  }

  setEditing (val: boolean) {
    this.editing = val
  }

  clickOutsideMiddleware (event: Event) {
    return true
  }

  get clickOutsideConfig () {
    return {
      events: ['mousedown'],
      handler: this.saveChanges,
      middleware: this.clickOutsideMiddleware
    }
  }
}
